import {AbstractModel} from '../../abstract-model';
import {FunnelLinkConditionType} from '../../../constants/funnel-link-condition-type';

export class FunnelLinkCondition extends AbstractModel {
  type: string | null = null;
  params: any = {};

  init(type: FunnelLinkConditionType): void {
    this.type = type;

    switch (type) {
      case FunnelLinkConditionType.LEAD_STATUS:
        this.params['condition'] = 'equal';
        this.params['value'] = 'ok';
        break;
    }
  }
}
